module.exports = __webpack_public_path__ + "static/media/grid-view.4b6bbb93.svg";